import { render, staticRenderFns } from "./W8FormPreviewPopup.vue?vue&type=template&id=d36d282c&"
import script from "./W8FormPreviewPopup.vue?vue&type=script&lang=js&"
export * from "./W8FormPreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports